// Routes redesigned in the stories group. Each entry: { path, element }.
// Entries here override the legacy routes in App.jsx for the same path.
// The /people and /people/:slug redirects stay in App.jsx and point at these pages.
import StoriesHubPage from "./StoriesHubPage.jsx";
import StoryPage from "./StoryPage.jsx";
import PhotosPage from "./PhotosPage.jsx";
import MeetingsPage from "./MeetingsPage.jsx";
import MeetingRecordPage from "./MeetingRecordPage.jsx";

export const routes = [
  { path: "/stories", element: <StoriesHubPage /> },
  { path: "/stories/:slug", element: <StoryPage /> },
  { path: "/media", element: <PhotosPage /> },
  { path: "/meetings", element: <MeetingsPage /> },
  { path: "/meetings/:slug", element: <MeetingRecordPage /> },
];
